export const formatDate = (isoDate?: string): string => {
  if (!isoDate) return '';

  const date = new Date(isoDate);
  const pad = (num: number) => num.toString().padStart(2, '0');

  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date
    .getFullYear()
    .toString()
    .slice(-2)} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
